module.exports = (__webpack_require__(7))(532);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/angular2-cookie/services/cookies.service.js from dll-reference vendor
// module id = 1211
// module chunks = 0